/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, { AxiosError } from 'axios';
import { Environment } from '../../../environment';
import { Api } from '../axiosApi';
import { ApiLogin } from '../axiosLogin';

export interface IListagemFaturamento {
  idmov: string;  
  idparceiro: string;
  emissao: string;
  numero: number;
  nome: string;
  tpag: number;
  tipo:number;
  cpf: string;
  total: number;
}
type TotalCount = {
    data: IListagemFaturamento[];
    totalCount: number;
    selecionado: number;
    total: number;
}
export interface IPagamentoData {
  id: string;
  indpag: number;
  tpag: string;
  caut?: string;
  cpf?: string;
  nome?: string;
  tcnpj?: string;
  tband?: string;
  promocao: boolean;
}
export interface IFaturar {
  idmov: string;
  idconta: string;
  datapgto: string;
}
export interface IFaturarid {
  idmov: string;
  datapgto: string;
}
export interface INFEData {
  id: string;
  indpag: number;
  tpag: string;
  caut?: string;
  tcnpj?: string;
  tband?: string;
  promocao: boolean;
}
export interface IGetFaturamento {
  idmov: string;
  emissao: Date;
  idplanodecontas: string;
  numero: string;
  vprod: number;
  total: number;
  desconto: number;
  acrescimo: number;
  idparceiro: string;
}
export interface IGetItensFaturamento{
  iditens: string;
  descricao: string;
  idmov: string;
  idprod: string;
  tpag: number;
  preco: number;
  total: number;
  qtds: number;
  un: string;
  tipo: number;
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}
const createnfe = async (dadosPagamento: INFEData): Promise<string | Blob | Error> => {
  try {
    const response = await Api.post('/geranfefat', dadosPagamento, {
      responseType: 'arraybuffer',
      validateStatus: (status) => [200, 201, 204].includes(status),
    });

    if (response.data && response.data.byteLength > 0) {
      const contentType = String(response.headers['content-type'] || '');
      const decodedString = new TextDecoder('utf-8').decode(response.data);
      if (contentType?.includes('application/pdf')) {
        return new Blob([response.data], { type: 'application/pdf' });
      }
      if (
        decodedString.startsWith('JVBERi0x') ||  
        decodedString.includes('trailer') ||     
        decodedString.endsWith('EOF=') ||       
        decodedString.length > 1000            
      ) {
        return decodedString; 
      }
      try {
        const jsonData = JSON.parse(decodedString);
        if (jsonData.pdf && typeof jsonData.pdf === 'string') {
          return jsonData.pdf;
        }
        if (jsonData.mensagem) {
          return jsonData.mensagem;
        }
      } catch {
        // Ignora erro, pois pode não ser JSON
      }
    }
    if (response.status === 204) {
      return 'NF-e processada com sucesso (sem conteúdo retornado).';
    }
    return new Error('Resposta inesperada do servidor.');
  } catch (error) {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError;

    if (axiosError.response) {
      const status = axiosError.response.status;

      let errorMessage = `Erro ${status}: ${axiosError.response.statusText}`;

      try {
        const data = axiosError.response.data;

        if (data instanceof ArrayBuffer) {
          const decoded = new TextDecoder('utf-8').decode(data);

          try {
            const json = JSON.parse(decoded);
            errorMessage =
              json?.errors?.default ||
              json?.mensagem ||
              decoded;
          } catch {
            errorMessage = decoded;
          }
        }
      } catch {
        // fallback
      }

      return new Error(errorMessage);
    } 
    
    if (axiosError.request) {
      return new Error('Nenhuma resposta do servidor. Verifique sua conexão.');
    }

    return new Error(`Erro na requisição: ${axiosError.message}`);
  }

  return new Error('Erro inesperado ao processar a requisição.');
}
};
const createnfce = async (dadosPagamento: IPagamentoData): Promise<Blob> => {
  try {
    const response = await Api.post('/geranfcefat', dadosPagamento, {
      responseType: 'arraybuffer',
    });

    const contentType = String(response.headers['content-type'] || '');
    if (contentType?.startsWith('application/pdf')) {
      return new Blob([response.data], { type: 'application/pdf' });
    }
    const decoded = new TextDecoder('utf-8').decode(response.data);
    const jsonData = JSON.parse(decoded);
    if (jsonData.pdf && jsonData.pdf.startsWith('JVBERi0x')) {
      const byteCharacters = atob(jsonData.pdf);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      return new Blob([new Uint8Array(byteNumbers)], {
        type: 'application/pdf',
      });
    }
    throw new Error(jsonData.mensagem || 'Resposta inesperada do servidor');
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data instanceof ArrayBuffer) {
      const decoded = new TextDecoder('utf-8').decode(error.response.data);
      try {
        const json = JSON.parse(decoded);
        throw new Error(json.message || 'Erro ao gerar NFC-e');
      } catch {
        throw new Error(decoded);
      }
    }
    throw new Error('Erro inesperado ao gerar NFC-e');
  }
};
const createfaturar = async (dados: IFaturar): Promise<string | Error> => {
  try {
    const response = await Api.post('/faturamento', dados, {
      responseType: 'arraybuffer',
    });
    if (response.status === 200 || response.status === 204 || response.status === 201) {
      return 'Registro faturado com sucesso';
    }
    return new Error(`Erro ao faturar: status ${response.status}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;

      if (axiosError.response) {

        let errorMessage = 'Erro desconhecido';

        try {
          const dataString = new TextDecoder().decode(axiosError.response.data as ArrayBuffer);
          const dataJson = JSON.parse(dataString);
          errorMessage = dataJson?.errors?.default || errorMessage;
        } catch {
          errorMessage = axiosError.response.statusText;
        }

        return new Error(errorMessage);
      }

      if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor. Verifique sua conexão.');
      }

      return new Error(`Erro na requisição: ${axiosError.message}`);
    }

    return new Error('Erro inesperado ao processar a requisição.');
  }
};
const createfaturarid = async (dados: IFaturarid): Promise<string | Error> => {
  try {
    const response = await Api.post('/faturamento', dados, {
      responseType: 'arraybuffer',
    });

    if (response.status === 200 || response.status === 204 || response.status === 201) {
      return 'Registro faturado com sucesso';
    }

    return new Error(`Erro ao faturar: status ${response.status}`);

  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;

      if (axiosError.response) {

        let errorMessage = 'Erro desconhecido';

        try {
          const dataString = new TextDecoder().decode(axiosError.response.data as ArrayBuffer);
          const dataJson = JSON.parse(dataString);
          errorMessage = dataJson?.errors?.default || errorMessage;
        } catch {
          errorMessage = axiosError.response.statusText;
        }

        return new Error(errorMessage);
      }

      if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor. Verifique sua conexão.');
      }

      return new Error(`Erro na requisição: ${axiosError.message}`);
    }

    return new Error('Erro inesperado ao processar a requisição.');
  }
};
const getAll = async (page = 1): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/faturamento?page=${page}&limit=${10}`;
    const { data, headers } = await Api.get(urlRelativa);  
    if (data) {
      return {
        
        data, 
        totalCount: Number(headers['x-total-count']|| 20),
        selecionado: Number(headers['x-total-selecionado'] || 0),
        total: Number(headers['x-total-valor'] || 0),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getByIdFaturamento = async (id: string): Promise<IGetItensFaturamento[] | Error> => {
  try {
    const { data } = await Api.get(`/faturamento/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
export const FaturamentoService = {  
  getAll,
  createfaturar,
  getByIdFaturamento,
  createnfce,
  createnfe,
  createfaturarid
};